import { Card, Stack, Title, Code, Text, Button, Group } from '@repletoryreach/sdk-ui';
import { notifyError, notifySuccess } from '@repletoryreach/sdk-ui/notifications';
import type { admin } from '@repletoryreach/sdk-api';
import { useT } from '../../../../i18n/I18nProvider';

type FlowRun = NonNullable<Awaited<ReturnType<typeof admin.listFlowRuns>>['data']>[number];

export function RawTab({ run }: { run: FlowRun }) {
  const t = useT();
  const json = JSON.stringify(run, null, 2);

  // The clipboard is denied often enough (an insecure origin, a locked-down
  // browser profile) that claiming success before the promise settles is a lie
  // the operator only discovers when they paste.
  async function copy() {
    try {
      await navigator.clipboard.writeText(json);
      notifySuccess(t('flows.view.raw.toast.copied'), t('flows.view.raw.toast.copiedTitle'));
    } catch {
      notifyError(t('flows.view.raw.toast.copyFailed'), t('flows.view.raw.toast.copyFailedTitle'));
    }
  }

  return (
    <Stack gap="lg">
      <Card withBorder>
        <Stack gap="md">
          <Group justify="space-between" align="baseline">
            <Title order={4}>{t('flows.view.raw.title')}</Title>
            <Button size="xs" variant="outline" onClick={() => void copy()}>{t('flows.view.raw.copy')}</Button>
          </Group>
          <Text role="caption" c="var(--rr-color-text-muted)">
            {t('flows.view.raw.shapeLead')} <code>GET /v1/admin/audit/flow-runs</code>. {t('flows.view.raw.usage')}
          </Text>
          <Code block style={{ maxHeight: 460 }}>{json}</Code>
        </Stack>
      </Card>
    </Stack>
  );
}
